export default {
  locale: "en",
  name: "Configuration manager",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "useCustomEmailTemplate",
        displayName: "Use custom templates",
        description: "Activate this to allow the user to create their own templates",
        helpText: "If no template is created and active the default template will be used",
      },
      {
        fieldName: "pedircodigoseguridad",
        displayName: "Activar campo CCV para PCIProxy",
        description: "Activa el campo CCV en el formulario de pago para el método PCI Proxy",
        helpText:
          "Actualmente sólo funciona para PCI Proxy pero podría expandirse para otros métodos de pago en el futuro",
      },
      {
        fieldName: "activeAbandonmentCart",
        displayName: "Activar email de abandono de carrito - LOYALTY",
        description: "Activar email de abandono de carrito - LOYALTY",
        helpText: "LOYALTY al iniciar sesión",
      },
      {
        fieldName: "activeAbandonmentCartNotLoyalty",
        displayName: "Activar email de abandono de carrito - SIN LOYALTY",
        description: "Activar email de abandono de carrito - SIN LOYALTY",
        helpText: "SIN LOYALTY cuando se introduce el email del huésped",
      },
      {
        fieldName: "useWebcampIntegration",
        description: "Utilizar integración con Webcamp",
        helpText: "Si está activo se utilizará Webcamp para la gestión de disponibilidad",
      },
      {
        fieldName: "keepMultiConfigOnRedirect",
        description: "Mantener apariencia al cambiar de motor",
      },
      {
        fieldName: "preventRestrictiveRateCombinations",
        description: "Aplicar siempre la tarifa más restrictiva",
      },
    ],
  },
};
